import { render } from "./MyAccounts.vue?vue&type=template&id=cf17df54&scoped=true"
import script from "./MyAccounts.vue?vue&type=script&lang=js"
export * from "./MyAccounts.vue?vue&type=script&lang=js"

import "./MyAccounts.vue?vue&type=style&index=0&id=cf17df54&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-cf17df54"]])

export default __exports__